import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoargeService {

  constructor() { }
  ClearLocalStorageWithoutCleverTapKeys(){
    // const clearExceptWZRK = () => {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
          if (!key.startsWith('WZRK_')) {
              localStorage.removeItem(key);
          }
      });
  // };
  }
}
